// Framework
import { Component, Output, EventEmitter } from '@angular/core';
// ngx-bootstrap
import { BsModalRef } from 'ngx-bootstrap/modal';
// Services
import { DataService } from '../../services/data.service';

@Component({
    selector: 'terms-of-service-modal',
    templateUrl: './terms-of-service-modal.component.html'
})

export class TermsOfServiceModalComponent {

    constructor (
        private dataSvc: DataService,
        public bsModalRef: BsModalRef
    ) {
    }

    dismissModal() {
        this.bsModalRef.hide();
    }
}